import React from 'react';
import './InventoryPage.scss';
import { withRouter } from 'react-router-dom';

const InventoryPage: React.FunctionComponent = () => <div className="page lg:shadow-xl rounded-lg bg-white p-6">TODO</div>;

export default withRouter(InventoryPage);
